import { createContext, useContext } from 'react';

import { emptyArray } from 'ui-components/default-props/empty';

import type { MfaEnrollment } from '@shipstation/client-common/mfa';

/**
 * G6 — load-bearing for `hooks/use-mfa-enrollment.js`,
 * `pages/settings/sign-in-and-security/sections/security/current-enrollments.jsx`, and
 * `components/mfa/mfa-enrollment-modal.jsx`. Do not change this shape.
 */
export type StepUpAuthContextValue = {
  accessToken: string;
  mfaEnrollments: MfaEnrollment[];
  detectAndHandleAuthTokenExpirationError: (error: unknown) => boolean;
};

const noopDetectAndHandleAuthTokenExpirationError = () => false;

/**
 * Lives outside both providers on purpose. The legacy provider (`../index.jsx`) and the
 * client-common adapter (`./step-up-auth-provider.tsx`) publish to this one context object, so
 * flipping `enable-client-common-step-up-auth` cannot leave a consumer reading the default
 * `accessToken: ''` and sending enrollment requests with an empty `mfaToken`.
 */
export const StepUpAuthContext = createContext<StepUpAuthContextValue>({
  accessToken: '',
  mfaEnrollments: emptyArray as MfaEnrollment[],
  detectAndHandleAuthTokenExpirationError: noopDetectAndHandleAuthTokenExpirationError,
});

export const useStepUpAuthContext = (): StepUpAuthContextValue => useContext(StepUpAuthContext);
